import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from './services/navigation.service';
import { ShopService } from './services/shop.service';
import { Order } from './models/order.model';
import { Page } from './models/page.model';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2/gst';

declare var ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'ngx-nooba-shop';
  activeCols$: any;
  activeCols = null;
  order$: any;
  order: Order = null;

  col0$: any;
  col0 = null;
  col1$: any;
  col1 = null;
  col2$: any;
  col2 = null;


  constructor(
    translate: TranslateService,
    private nav: NavigationService,
    private shop: ShopService,
    private cdr: ChangeDetectorRef,
    private angulartics2: Angulartics2GoogleGlobalSiteTag,

  ) {
    this.angulartics2.startTracking();

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('de');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    const lang = localStorage.getItem('lang');
    if (lang) {
      translate.use(lang);
    } else {
      translate.use('de');
    }

  }

  ngOnInit() {
    this.shop.getPages().subscribe(
      (p: Array<Page>) => {
        this.shop.pages.next(p);
      }
    );
  }


  ngAfterViewInit() {
    this.col0$ = this.nav.col0.subscribe(c => {
      this.col0 = c;
      this.cdr.detectChanges();
    });
    this.col1$ = this.nav.col1.subscribe(c => {
      this.col1 = c;
      this.cdr.detectChanges();
    });
    this.col2$ = this.nav.col2.subscribe(c => {
      this.col2 = c;
      this.cdr.detectChanges();
    });
    this.order$ = this.shop.order.subscribe((o) => {
      this.order = o;
      this.cdr.detectChanges();
    });
  }

  isMobile() {
    return window.innerWidth < 1150;
  }
}
